(function() {
  if (!window.location.pathname.includes('lucyd-armor-test')) return;

  function injectWidget() {
    var orderBtn = document.querySelector('button[data-id="gNj1bVnriF"]');
    if (!orderBtn) return false;
    if (document.getElementById('armor-volume-pricing')) return true;

    var productBtn = orderBtn.closest('gp-product-button');
    if (!productBtn) return false;

    var widget = document.createElement('div');
    widget.id = 'armor-volume-pricing';
    widget.style.cssText = 'width:100%; margin-bottom:16px; font-family:var(--g-font-paragraph, sans-serif);';
    widget.innerHTML = '<div style="margin-bottom:8px;"><span style="font-weight:700; font-size:16px; color:#121212;">Bundle &amp; Save</span><span style="font-size:13px; color:#666; margin-left:6px;">Best deals selected for you!</span></div>'
      + '<label class="avp-tier" data-tier="1" data-qty="1" style="display:flex; align-items:center; gap:12px; padding:12px 14px; border:2px solid #DBFF00; border-radius:10px; margin-bottom:8px; cursor:pointer; background:#FAFFF0; position:relative;"><input type="radio" name="avp_tier" value="1" checked style="accent-color:#DBFF00; width:18px; height:18px; flex-shrink:0;"><div style="flex:1; display:flex; justify-content:space-between; align-items:center;"><div><div style="font-weight:600; font-size:14px; color:#121212;">1 Pair</div></div><div style="text-align:right;"><div style="font-weight:700; font-size:15px; color:#121212;">$149.00</div></div></div></label>'
      + '<label class="avp-tier" data-tier="2" data-qty="2" style="display:flex; align-items:center; gap:12px; padding:12px 14px; border:2px solid #e0e0e0; border-radius:10px; margin-bottom:8px; cursor:pointer; background:#fff; position:relative;"><input type="radio" name="avp_tier" value="2" style="accent-color:#DBFF00; width:18px; height:18px; flex-shrink:0;"><div style="flex:1; display:flex; justify-content:space-between; align-items:center;"><div><div style="font-weight:600; font-size:14px; color:#121212;">2 Pairs <span style="font-size:12px; font-weight:400; color:#666;">Starter</span></div><div style="font-size:12px; color:#d4371c; font-weight:600;">10% OFF</div></div><div style="text-align:right;"><div style="font-weight:700; font-size:15px; color:#121212;">$268.20</div><div style="font-size:12px; color:#999; text-decoration:line-through;">$298.00</div></div></div><span style="position:absolute; top:-9px; right:12px; background:#DBFF00; color:#000; font-size:10px; font-weight:700; padding:2px 8px; border-radius:4px; text-transform:uppercase;">Most Popular</span></label>'
      + '<label class="avp-tier" data-tier="3" data-qty="6" style="display:flex; align-items:center; gap:12px; padding:12px 14px; border:2px solid #e0e0e0; border-radius:10px; margin-bottom:8px; cursor:pointer; background:#fff; position:relative;"><input type="radio" name="avp_tier" value="3" style="accent-color:#DBFF00; width:18px; height:18px; flex-shrink:0;"><div style="flex:1; display:flex; justify-content:space-between; align-items:center;"><div><div style="font-weight:600; font-size:14px; color:#121212;">6 Pack</div><div style="font-size:12px; color:#d4371c; font-weight:600;">BUY 5 GET 1 FREE</div></div><div style="text-align:right;"><div style="font-weight:700; font-size:15px; color:#121212;">$745.00</div><div style="font-size:12px; color:#999; text-decoration:line-through;">$894.00</div></div></div></label>'
      + '<label class="avp-tier" data-tier="4" data-qty="20" style="display:flex; align-items:center; gap:12px; padding:12px 14px; border:2px solid #e0e0e0; border-radius:10px; margin-bottom:8px; cursor:pointer; background:#fff; position:relative;"><input type="radio" name="avp_tier" value="4" style="accent-color:#DBFF00; width:18px; height:18px; flex-shrink:0;"><div style="flex:1; display:flex; justify-content:space-between; align-items:center;"><div><div style="font-weight:600; font-size:14px; color:#121212;">20 Pack <span style="font-size:12px; font-weight:400; color:#666;">Best Value</span></div><div style="font-size:12px; color:#d4371c; font-weight:600;">30% OFF</div></div><div style="text-align:right;"><div style="font-weight:700; font-size:15px; color:#121212;">$2,086.00</div><div style="font-size:12px; color:#999; text-decoration:line-through;">$2,980.00</div></div></div><span style="position:absolute; top:-9px; right:12px; background:#121212; color:#fff; font-size:10px; font-weight:700; padding:2px 8px; border-radius:4px; text-transform:uppercase;">Best Value</span></label>';

    productBtn.parentNode.insertBefore(widget, productBtn);

    var tiers = widget.querySelectorAll('.avp-tier');
    var radios = widget.querySelectorAll('input[name="avp_tier"]');

    function updateStyles() {
      tiers.forEach(function(t) {
        var r = t.querySelector('input[type="radio"]');
        t.style.borderColor = r.checked ? '#DBFF00' : '#e0e0e0';
        t.style.background = r.checked ? '#FAFFF0' : '#fff';
      });
    }

    function updateQuantity(qty) {
      var form = document.querySelector('form[action="/cart/add"]');
      if (form) {
        var qi = form.querySelector('input[name="quantity"]');
        if (qi) { qi.value = qty; }
        else {
          qi = document.createElement('input');
          qi.type = 'hidden'; qi.name = 'quantity'; qi.value = qty;
          form.appendChild(qi);
        }
      }
    }

    radios.forEach(function(r) {
      r.addEventListener('change', function() {
        updateStyles();
        updateQuantity(parseInt(this.closest('.avp-tier').getAttribute('data-qty')));
      });
    });

    tiers.forEach(function(t) {
      t.addEventListener('click', function(e) {
        if (e.target.tagName !== 'INPUT') {
          var r = this.querySelector('input[type="radio"]');
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    updateQuantity(1);
    return true;
  }

  function keepOrderVisible() {
    var btn = document.querySelector('button[data-id="gNj1bVnriF"]');
    if (!btn) return;
    btn.style.setProperty('display', 'inline-flex', 'important');
    btn.style.setProperty('visibility', 'visible', 'important');
    btn.style.setProperty('opacity', '1', 'important');
    btn.removeAttribute('gp-data-hidden');
    var p = btn.parentElement;
    if (p) { p.style.setProperty('display', 'block', 'important'); p.style.setProperty('visibility', 'visible', 'important'); }
    var gp = btn.closest('gp-button');
    if (gp) { gp.style.setProperty('display', 'block', 'important'); gp.style.setProperty('visibility', 'visible', 'important'); }
    var gpb = btn.closest('gp-product-button');
    if (gpb) { gpb.style.setProperty('display', 'block', 'important'); gpb.style.setProperty('visibility', 'visible', 'important'); }
    var svg = btn.querySelector('svg.gp-invisible');
    if (svg) { svg.style.setProperty('display', 'none', 'important'); }
  }

  var attempts = 0;
  var iv = setInterval(function() {
    attempts++;
    keepOrderVisible();
    if (injectWidget() || attempts > 40) clearInterval(iv);
  }, 300);

  document.addEventListener('DOMContentLoaded', function() { injectWidget(); keepOrderVisible(); });
  window.addEventListener('load', function() { injectWidget(); keepOrderVisible(); });

  var ka = setInterval(keepOrderVisible, 1000);
  setTimeout(function() { clearInterval(ka); }, 10000);
})();